<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <RecordFeatureFlag
        v-for="featureFlag in results"
        :key="featureFlag.id"
        :featureFlag="featureFlag" />
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordFeatureFlag from './components/RecordFeatureFlag'
import Table from '@mixins/Table'

export default {
  mixins: [Table],
  components: { RecordFeatureFlag },
  data() {
    return {
      paginationOptions: {
        name: 'featureFlag',
        service: 'featureFlag',
        searchIn: [
          'key',
        ],
      },
    }
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Feature flags"
  }
}
</i18n>
